import Record from "slotworks/model/gameplay/records/record";
import { ExpansionResult } from "./results/expansion-result";

export default class SpinRecord extends Record {

    /** ID for debugging purposes */
    public id: string = "SpinRecord";

    public reelset: string[][];

    /**
     * 2D array of reels, containing symbiols
     * e.g [reel, reel, reel, reel, reel]
     */
    public grid: string[][];
    /**
     * Persistent grid which includes anything that "stuck" from last spin, or added to the reels before the spin stops
     */
    public overlayGrid: string[][];

    public stops: number[];

    /**
     * Returns grid with any ExpansionResults applied overtop
     */
    public getFinalGrid() {

        const finalGrid = this.grid.map((reel) => reel.map((symbol) => symbol));

        this.getResultsOfType(ExpansionResult).forEach((expansionResult) => {
            expansionResult.expansions.forEach((expansion) => {
                finalGrid[expansion.x][expansion.y] = expansionResult.targetSymbolID;
            });
        });

        return finalGrid;
    }
}
